<template>
	
 
  <div class="order-details">
    <!-- 给header上与data上加on为退款订单-->
	 	<div class="user">
	
	
	  <div class="topheader header bg-color-red">
        <div class="topheader-left">
		 <div  @click="goBack()">
        <img src="@assets/images/back2.png"   style="width:20px;height:20px;margin-top:3px"/>
      </div>
		</div>
        <div class="topheader-center">订单详情</div>
        <div class="topheader-right"> </div>
    </div>
	
	
	
     
    </div>
	
   	 
    <template  >
      <div class="nav">
        <div class="navCon acea-row row-between-wrapper">
          <div :class="{ on: orderInfo.state ==1 }">
            待审核
          </div>
          <div
            :class="{ on: orderInfo.state ==2 }"
            
          >
            待入库
          </div>
          
          <div
            :class="{ on: orderInfo.state === 3 }"
           
          >
            已完成
          </div>
          
        </div>
        <div class="progress acea-row row-between-wrapper">
          <div
            class="iconfont"
            :class="[
              orderInfo.state ==1 
                ? 'icon-webicon318'
                : 'icon-yuandianxiao',
              orderInfo.state >= 1 ? 'font-color-red' : ''
            ]"
          ></div>
          <div
            class="line"
            :class="{ 'bg-color-red': orderInfo.state > 1 }"
          ></div>
          <div
            class="iconfont"
            :class="[
              orderInfo.state ==2 ? 'icon-webicon318' : 'icon-yuandianxiao',
              orderInfo.state >= 2 
                ? 'font-color-red'
                : ''
            ]"
          ></div>
        
           
          <div
            class="line"
            :class="{
              'bg-color-red':
                orderInfo.state > 2 
            }"
          ></div>
          <div
            class="iconfont"
            :class="[
              orderInfo.state == 3 ? 'icon-webicon318' : 'icon-yuandianxiao',
              orderInfo.state >= 3 
                ? 'font-color-red'
                : ''
            ]"
          ></div>
        </div>
      </div>
      
     
     
      
      <div class="line"  >
        <img src="@assets/images/line.jpg" />
      </div>
    </template>
    
  
    <div class="wrapper">
	 
      <div class="item acea-row row-between">
        <div>采购单号：</div>
        <div class="conter acea-row row-middle row-right">
          {{ orderInfo.danhao
          }} 
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>订单时间：</div>
        <div class="conter">
          {{ orderInfo.tijiaoriqi }}
        </div>
      </div>
  
      
       
    </div>
	
	  <div class="scroll-container">
 <OrderGoods
      :edit="edit"
	  @custom-event="reload"
	 
      :cartInfo="orderInfo.cartInfo || []"
    ></OrderGoods>
       </div>
   
    
    <div style="height:1rem;"  ></div>
    <div
      class="footer acea-row row-right row-middle" v-if="orderInfo.state == 1"
    
    >
	
	 <template v-if="orderInfo.state == 1">
        <div class="bnt bg-color-red" @click="editOrder" v-if="edit==false">修改供应商</div>
       <div class="bnt bg-color-red "    @click="quxiaoeditOrder" v-if="edit==true">取消修改</div>
	     <div class="bnt bg-color-red" style="background-color: #16b777 !important;" @click="shenhe">
          审核完成
        </div>
      </template>
	  
    
   
    
    </div>
  
    
 
  </div>
</template>
<style scoped>
/* 布局调整 */
.order-details {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 全视口高度 */
  overflow: hidden; /* 隐藏外部滚动条 */
}

/* 新增滚动容器样式 */
.scroll-container {
  flex: 1; /* 占据剩余空间 */
  overflow-y: auto; /* 启用垂直滚动 */
  -webkit-overflow-scrolling: touch; /* 移动端平滑滚动 */
}

.goodCall {
  color: #e93323;
  text-align: center;
  width: 100%;
  height: 0.86rem;
  padding: 0 0.3rem;
  border-bottom: 0.01rem solid #eee;
  font-size: 0.3rem;
  line-height: 0.86rem;
  background: #fff;
}
.iconfont {
  margin-right: 0.15rem;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.order-details .writeOff {
  background-color: #fff;
  margin-top: 0.13rem;
  padding-bottom: 0.3rem;
}
.order-details .writeOff .title {
  font-size: 0.3rem;
  color: #282828;
  height: 0.87rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.3rem;
  line-height: 0.87rem;
}
.order-details .writeOff .grayBg {
  background-color: #f2f5f7;
  width: 5.9rem;
  height: 3.84rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin: 0.5rem auto 0 auto;
  padding-top: 0.55rem;
}
.order-details .writeOff .grayBg .pictrue {
  width: 1rem;
  height: 1rem;
  margin: 0 auto;
}
  .pictrue img {
   
}
.order-details .writeOff .gear {
  width: 5.9rem;
  height: 0.3rem;
  margin: 0 auto;
}
.order-details .writeOff .gear img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .num {
  background-color: #f0c34c;
  width: 5.9rem;
  height: 0.84rem;
  color: #282828;
  font-size: 0.48rem;
  margin: 0 auto;
  border-radius: 0 0 0.2rem 0.2rem;
  text-align: center;
  padding-top: 0.04rem;
}
.order-details .writeOff .rules {
  margin: 0.46rem 0.3rem 0 0.3rem;
  border-top: 0.01rem solid #f0f0f0;
  padding-top: 0.1rem;
}
.order-details .writeOff .rules .item {
  margin-top: 0.15rem;
}
.order-details .writeOff .rules .item .rulesTitle {
  font-size: 0.28rem;
  color: #282828;
}
.order-details .writeOff .rules .item .rulesTitle .iconfont {
  font-size: 0.3rem;
  color: #333;
  margin-right: 0.08rem;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info .time {
  margin-left: 0.2rem;
}
.order-details .map {
  height: 0.86rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.86rem;
  border-bottom: 0.01rem solid #f0f0f0;
  margin-top: 0.13rem;
  background-color: #fff;
  padding: 0 0.3rem;
}
.order-details .map .place {
  font-size: 0.26rem;
  width: 1.76rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
}
.order-details .map .place .iconfont {
  font-size: 0.27rem;
  height: 0.27rem;
  line-height: 0.27rem;
  margin: 0.02rem 0.03rem 0 0;
}
.order-details .address .name .iconfont {
  font-size: 0.34rem;
  margin-left: 0.1rem;
}
</style>

<script>
import OrderGoods from "@components/CaigouGoods";
import { ordercaigouDetail, orderAgain } from "@api/order";
import ClipboardJS from "clipboard";
 
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import {
  cancelOrderHandle,tuihuiOrderHandle,
  takeOrderHandle,zhipeishenheHandle,
  delOrderHandle,
  payOrderHandle
} from "@libs/order";
import { wechatEvevt } from "@libs/wechat";
import GeneralWindow from "@components/GeneralWindow";
const NAME = "OrderDetails";
export default {
  name: NAME,
  components: {
    OrderGoods,
    GeneralWindow
  },
  props: {},
  data: function() {
    return {
      offlinePayStatus: 2,
      orderTypeName: "采购订单",
      orderTypeNameStatus: true,
      offlineStatus: true,
      id: this.$route.params.id,
	  dm_id: this.$route.params.dm_id,
      orderInfo: {
        _status: {}
      },
	   edit:false,
      status: {},
      pay: false,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      system_store: {},
      mapKay: "",
      mapShow: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  computed: {
  
   // ...mapGetters(["userInfo"])
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
		 this.dm_id = n.params.dm_id;
        this.getDetail();
      }
    }
  },
  inject: ["app"],
  mounted: function() {
    this.getDetail();
    this.$nextTick(function() {
      let copybtn = document.getElementsByClassName("copy-data");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
      });
    });
  },
  methods: {
    reload() {
	 this.getDetail();
      console.log('父组件方法被调用');
	    this.showChild = false;
      this.$nextTick(() => {
        this.showChild = true;
      });
    },
   editOrder() {
	 this.edit=true;
	 },
	 quxiaoeditOrder() {
	 this.edit=false;
	 },
    // 再次购买
    goOrderConfirm(e) {
      orderAgain(e.order_id)
        .then(res => {
          this.$router.push({
            path: "/order/submit/" + res.data.cateId
          });
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.getDetail();
    },
    showChang: function() {
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.system_store.latitude),
          longitude: parseFloat(this.system_store.longitude),
          name: this.system_store.name,
          address: this.system_store._detailed_address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暂无法使用查看地图，请配置您的腾讯地图key"
          );
        this.mapShow = true;
      }
    },
    goBack() {
      const history = this.app.history,
        last = history[history.length - 1] || {};
	 
      if (last.name === "Caigou") return this.$router.go(-1);
      else return this.$router.replace({ path: "/" });
    },
    cancelOrder() {
	   const id = this.id;
	   const dm_id = this.dm_id;
      tuihuiOrderHandle(id,dm_id)
        .then(() => {
          setTimeout(() => this.goBack(), 300);
        })
        .catch(() => {
          this.getDetail();
        });
    },
    takeOrder() {
      this.$dialog.loading.open("正在加载中");
      takeOrderHandle(this.orderInfo.order_id)
        .then(res => {
          if (
            (res.data.gain_integral != "0.00" &&
              res.data.gain_coupon != "0.00") ||
            (res.data.gain_integral > 0 && res.data.gain_coupon > 0)
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${res.data.gain_coupon}元优惠券以及${
                res.data.gain_integral
              }积分，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠礼包"
            };
            return;
          } else if (
            res.data.gain_integral != "0.00" ||
            res.data.gain_integral > 0
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${
                res.data.gain_integral
              }积分，购买商品时可抵现哦～`,
              title: "赠送积分"
            };
            return;
          } else if (
            res.data.gain_coupon != "0.00" ||
            res.data.gain_coupon > 0
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${
                res.data.gain_coupon
              }元优惠券，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠券"
            };
            return;
          } else {
            this.$dialog.loading.close();
            this.$dialog.success("收货成功");
          }
          this.getDetail();
        })
        .catch(res => {
          this.$dialog.loading.close();
          this.$dialog.error(res.msg);
        });
    },
    shenhe() {
      zhipeishenheHandle(this.orderInfo.id).then(() => {
        setTimeout(() => this.goBack(), 300);
      });
    },
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1 && that.orderTypeNameStatus === true) {
        that.payType.push("offline");
      }
    },
    getOrderStatus: function() {
      let orderInfo = this.orderInfo || {},
        _status = orderInfo._status || { _type: 0 },
        status = {};
      let type = parseInt(_status._type),
        delivery_type = orderInfo.delivery_type,
        seckill_id = orderInfo.seckill_id ? parseInt(orderInfo.seckill_id) : 0,
        bargain_id = orderInfo.bargain_id ? parseInt(orderInfo.bargain_id) : 0,
        combination_id = orderInfo.combination_id
          ? parseInt(orderInfo.combination_id)
          : 0;
      status = {
        type: type,
        class_status: 0
      };
      if (type === 1 && combination_id > 0) {
        status.type = 6;
        status.class_status = 1;
      } //查看拼团
      if (type === 2 && delivery_type === "express") status.class_status = 2; //查看物流
      if (type === 2) status.class_status = 3; //确认收货
      if (type === 4 || type === 0) status.class_status = 4; //删除订单
      if (
        !seckill_id &&
        !bargain_id &&
        !combination_id &&
        (type === 3 || type === 4)
      )
        status.class_status = 5; //再次购买
      if (type == 9) {
        //线下付款
        status.class_status = 0;
        this.offlineStatus = false;
      }
      this.status = status;
    },
    getDetail() {
      const id = this.id;
	 
      if (!id) return this.$dialog.error("订单不存在");
	
      ordercaigouDetail(id)
        .then(res => {
		console.log(res);
          this.orderInfo = res.data;
         // this.getOrderStatus();
        
        //  this.system_store = res.data.system_store || {};
         // this.mapKey = res.data.mapKey;
         // this.setOfflinePayStatus(this.orderInfo.offlinePayStatus);
       
        })
        .catch(err => {
          this.$dialog.error(err.msg);
        // this.$router.go(-1);
        });
    },
    async toPay(type) {
      var that = this;
      await payOrderHandle(this.orderInfo.order_id, type, that.from)
        .then(() => {})
        .catch(res => {
          if (res.status === "WECHAT_H5_PAY")
            that.$router.push({
              path: "/order/status/" + that.orderInfo.order_id + "/0"
            });
        });
      that.getDetail();
    }
  }
};
</script>
